import {
  DialogContent,
  DialogTitle,
  IconButton,
  styled,
  Typography,
} from "@mui/material";
import "./common.css";
import noop from "lodash/noop";
import { memo } from "utils/memo";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";

export const DialogStatementTypography = styled(Typography)(() => ({
  fontSize: "15px",
  fontWeight: 500,
  paddingBottom: "20px",
}));

interface CashDDialogProps {
  title?: string;
  open?: boolean;
  handleClose?: any;
  children?: any;
  fullWidth?: boolean;
  maxWidth?: "xl" | "lg" | "md" | "sm" | false;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-container": {
    height: "100%",
  },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    width: "100%",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const CashDDialog = ({
  title,
  handleClose = noop,
  children,
  maxWidth = "lg",
  open = false,
  fullWidth = false,
}: CashDDialogProps) => {
  return (
    <BootstrapDialog
      onClose={handleClose}
      open={open}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      disableEscapeKeyDown
      sx={{ padding: "20px" }}
    >
      {title && (
        <>
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            {title}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={() => handleClose(false)}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
        </>
      )}
      <DialogContent dividers>{children}</DialogContent>
    </BootstrapDialog>
  );
};

export default memo(CashDDialog);
